import { jsxs, jsx } from 'react/jsx-runtime';
import { cssTextEllipsis } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { containerPreviewCompact } from '../ResourcePreviewGrid/cssPreviewContainer.js';
import { styled } from 'styled-components';

const IconFileName = ({ title, extension, className }) => {
  return /* @__PURE__ */ jsxs(FileNameBadge, {
    className,
    children: [
      /* @__PURE__ */ jsx(Title, {
        children: title
      }),
      extension && /* @__PURE__ */ jsxs(Ext, {
        children: [
          ".",
          extension
        ]
      })
    ]
  });
};
const Title = styled.span.withConfig({
  displayName: "IconFileName__Title",
  componentId: "sc-878c2e61-0"
})([
  ``,
  `;`
], cssTextEllipsis);
const Ext = styled.span.withConfig({
  displayName: "IconFileName__Ext",
  componentId: "sc-878c2e61-1"
})([
  `word-break:keep-all;`
]);
const FileNameBadge = styled.div.withConfig({
  displayName: "IconFileName__FileNameBadge",
  componentId: "sc-878c2e61-2"
})([
  `position:relative;max-width:min(200px,100%);text-align:center;background:`,
  `;color:`,
  `;border-radius:0.5rem;padding:0.375rem 0.5rem;font-weight:400;font-size:0.75rem;width:fit-content;display:none;`,
  `{display:flex;overflow:hidden;}`
], cssVar["color-bg-secondary-button"], cssVar["color-text-tertiary"], containerPreviewCompact);

export { IconFileName };
//# sourceMappingURL=IconFileName.js.map
